import React, { PropsWithChildren } from "react";
import { SidebarSectionSlotName } from "@/components/layout/components/sidebar/sidebar-section/sidebar-section.types";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";
import styled from "@emotion/styled";

interface SidebarSectionProps extends PropsWithChildren {
  isExpanded: boolean;
}

export const SidebarSection = ({ children, isExpanded }: SidebarSectionProps) => {
  const unslottedChildren = getUnslottedChildren(children);
  const header = getSlot(children, SidebarSectionSlotName.Header);

  return (
    <StyledContainer>
      {header}
      {isExpanded && <StyledContentContainer>{unslottedChildren}</StyledContentContainer>}
    </StyledContainer>
  );
};

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["0.5"]};
`;

export const StyledContentContainer = styled.div``;
